import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("footer", { class: "ezGolf-footer pt-2 mt-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "clearfix mb-0" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "float-md-left d-block d-md-inline-block mt-25" }, " Powered by ezCloud ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationHeaderVue = _resolveComponent("NavigationHeaderVue")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_NavigationHeaderVue, {
      class: "mb-2",
      componentActive: $setup.urlProps
    }, null, 8, ["componentActive"]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _hoisted_1
  ]))
}